import {Counter} from './Counter'
import {sendTimeMark} from './sendTimeMark'
import {time} from './time'
import {timeEnd} from './timeEnd'
import {updateAdditional} from './updateAdditional'
import {logError} from './logError'
import {logEvent} from './logEvent'

export const RUM = {
  Counter,
  sendTimeMark,
  time,
  timeEnd,
  updateAdditional,
  logError,
  logEvent
}
